if(!customElements.get('marcas-grid')){
  customElements.define('marcas-grid', class MarcasGrid extends HTMLElement {
    constructor(){
      super();

      this.activateNavigation = JSON.parse(this.getAttribute('navigation'))
      this.featuredVendors = JSON.parse(JSON.parse(this.getAttribute('data-featured-vendors')))
      this.collections = JSON.parse(JSON.parse(this.getAttribute('data-all-vendors')))
      this.vendors = []
      this.featuredVendorLink = document.querySelector('[featured-vendor-link]')

      this.customVendors = JSON.parse(JSON.parse(this.getAttribute('data-custom-vendor')))

      this.imageSettings = {
        shape:  this.getAttribute('data-media-shape').replace('default_', ''),
        aspect: this.getAttribute('data-media-aspect')
      }
    
      if(!!this.collections && !!this.customVendors){
        this.collections.push(...this.customVendors)
     
      }
      if(!!this.featuredVendors && !!this.customVendors){
        this.featuredVendors.push(...this.customVendors)
      }

      this.containerFeaturedVendor = document.querySelector('[featured-vendors]')
      this.containerLetters = document.querySelector('[letters]')
      this.containerVendors = document.querySelector('[vendors]')

      this.shape_id = this.getAttribute('id')
      this.totalProducts = this.getAttribute('products-count') || 0

      if(!!this.collections){
        this.getVendors()
        this.printLetters()
        this.printVendors()
      }

      !!this.featuredVendors && this.printFeaturedVendors()

      this.assignEvents()
    }

    assignEvents = () => {

      window.addEventListener('scroll', () => { 
        this.querySelector('.marcas').classList.toggle('sticky-bar', window.pageYOffset > 350)
      })

      const childsLetters = !!this.collections ? document.querySelectorAll('.letter-single') : undefined

      !!childsLetters && childsLetters.forEach(child => 
        child.addEventListener('click', () => this.scrollPage(child.innerText))
      )

      !!this.activateNavigation &&
      this.featuredVendorLink?.addEventListener('click', () => this.scrollPage('star'))
    }

    scrollPage = (letter) => {

      
      const offsetY = letter === 'star' 
      ? 300 
      : document.querySelector(`[data-letter=${letter}]`).getBoundingClientRect()?.top
      
      window.scroll({
        top: offsetY,
        left: 0,
        behavior: 'smooth'
      });
      
    }

    getAlternNumber = () => {
      return Math.floor(Math.random() * this.totalProducts);
    }

    getVendors(){
      const map = this.collections.reduce((acc, val) => {
        let char = val?.vendor.charAt(0).toUpperCase();
        acc[char] = [].concat((acc[char] || []), val);
        return acc;
      }, {});
      this.vendors = Object.keys(map).map(el => ({
          letter: el,
          products: map[el]
      }));
    }

    printLetters(){
      this.vendors?.forEach(letter => {
        this.containerLetters.innerHTML += `<div class="letter-single">${letter.letter}</div>`
      })
    }

    singleColumnHTML(data){
      function escapeHtml(s){
          const text = document.createTextNode(s),
          p = document.createElement('div');
          p.appendChild(text);
          return p.innerHTML;
      }

      return `
      <div class="col-span-1 column-vendor">
        ${data?.url ? `<a href="${data?.url}">` : null}
          <div class="image-container media-shape-container relative z-10">
            ${
              data?.image != 'null' ? 
              `
              <svg class="media-svg relative" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <foreignObject class="foreign-object-img w-full h-full object-cover media--style bg-scheme-card" -webkit-clip-path="url(#clip-${this.shape_id}-${this.getAlternNumber()})" clip-path="url(#clip-${this.shape_id}-${this.getAlternNumber()})" width="100%" height="100%">
                <div class="media-style-container ${this.imageSettings.shape}">
                  <div class="${this.imageSettings.aspect}  w-full h-full">
                    <img class="media-style" src="${data.image}"loading="lazy" onload='this.style.color="currentColor"' alt="${data?.title}" style="color: currentcolor;" />
                  </div>
                </div>
                </foreignObject>
              </svg>
              ` 
              : `` 
            }
          </div>
          <div class="title-vendor text-base font-body uppercase">
            ${data?.title}
          </div>
          <div class="description">
            ${data?.description && escapeHtml(data?.description)}
          </div>
        ${data?.url ? `</a>` : null}
      </div>
      `
    }

    printVendors(){
      this.vendors?.map(letter => {
        this.containerVendors.innerHTML += 
        `
        <section class="letter-container max-w-site" data-letter="${letter.letter}">
          <div class="letter-header">
            ${letter.letter}
          </div>
          
          <div class="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-2">
            ${
              letter.products.map((vendor) => vendor.vendor ? this.singleColumnHTML({
                  title: vendor.vendor,
                  image: vendor.featured_image || null,
                  description: vendor.description,
                  url: vendor.url
                }) : null
              ).join('')
            }
          </div>

        </section>
        `
      })
    }

    printFeaturedVendors = () => {
      this.containerFeaturedVendor.innerHTML = `
        <div class="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-2">
          ${
            this.featuredVendors?.map(vendor => {
              return `
                  ${
                    this.singleColumnHTML({
                        title: vendor.vendor,
                        image: vendor.featured_image || null,
                        description: vendor.description,
                        url: vendor.url
                      })
                  }
                `
            }).join('')
          }
        </div>
      `
    }
  })
}
